import { appCloudfrontPath } from '@constants';
import axios from 'axios';
import { DataVisualizationDetails } from 'types/charts';

export const getDataVisualization = async (dataVisualizationName: string): Promise<DataVisualizationDetails> => {
	const dataVisualizationUrl = `${appCloudfrontPath}/data-visualizations/${dataVisualizationName}.json`;
	return axios.get(dataVisualizationUrl).then((response) => response.data);
};
